export default class Tabs {
    /*
    * This class is used to create a tabs module.
    * Description of elements to use:
    * .js-tab-nav : element class that is clicked to change tab
    * .tab-nav--active : class of the currently active element
    * data-tabs="": attribute that must be inserted on the same element .js-tab-nav. The value must be the id of the .js-tab-content to show
    * .js-tab-content: class of the element that contains the contents of the tab and the id used as the value in the data-tab
    * .js-tab-mobile-nav: element class that is clicked to open tab in mobile
    */
    constructor() {
        // Add events
        this.addEvents();  
    }

    /*
     * Add events
     */
    addEvents() {
        /*
        * Toggle tabs Desktop
        */
        $('.js-tab-nav').on('click', e => {
            e.preventDefault();
            $('.tab-nav--active').removeClass('tab-nav--active');
            $(e.currentTarget).addClass('tab-nav--active');

            $('.js-tab-content').hide();

            let tab_id = $(e.currentTarget).attr('data-tabs'); 
            $( '#'+tab_id).show(); 
         });

        /*
        * Toggle tabs Mobile
        */
         $('.js-tab-mobile-nav').on('click', e => {
            e.preventDefault();
            if( !$(e.currentTarget).hasClass('tab-mobile-nav--active') ){
                $('.tab-mobile-nav--active').removeClass('tab-mobile-nav--active');
                $(e.currentTarget).addClass('tab-mobile-nav--active');
                
                $('.js-tab-content').slideUp();  

                let tab_id = $(e.currentTarget).attr('data-tabs'); 
                $( '#'+tab_id).slideDown();
            }
        });  
        
    }
}